import cComponents from "../../web-sh/src/components/common";

import UserAvatar from "./UserAvatar";
import AllBrowsers from "./AllBrowsers";
import Onboarding from "./Onboarding";
import PageHeader from "./PageHeader";
import BusyOverlay from "./BusyOverlay";
import ChatwootWidget from "./ChatwootWidget";
import AuthLogo from "./AuthLogo";

cComponents.UserAvatar = UserAvatar;
cComponents.PageHeader = PageHeader;
cComponents.AuthLogo = AuthLogo;

const commonComponents = {
  ...cComponents,
  AllBrowsers,
  Onboarding,
  BusyOverlay,
  ChatwootWidget
}

export default commonComponents